import React, { useState } from 'react';
import {
  Box,
  Container,
  Paper,
  Typography,
  TextField,
  Button,
  Chip,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  Card,
  CardContent,
  Avatar,
  Divider,
  IconButton,
  Alert,
  Snackbar
} from '@mui/material';
import {
  Add as AddIcon,
  Delete as DeleteIcon,
  CloudUpload as CloudUploadIcon,
  Article as ArticleIcon,
  Person as PersonIcon,
  Category as CategoryIcon,
  Image as ImageIcon,

} from '@mui/icons-material';
import CancelIcon from '@mui/icons-material/Cancel';
import CircularProgress from '@mui/material/CircularProgress';
import { useNavigate } from 'react-router';
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { getFirestore, collection, addDoc } from "firebase/firestore";
const BlogPostForm = () => {
  const [formData, setFormData] = useState({
    title: '',
    content: '',
    author: {
      name: '',
      bio: '',
      avatar: ''
    },
    category: '',
    tags: [],
    featuredImage: '',
    additionalImages: []
  });
  const [uploading, setUploading] = useState(false);
  const [currentTag, setCurrentTag] = useState('');
  const [currentImage, setCurrentImage] = useState('');
  const [showSuccess, setShowSuccess] = useState(false);
  const navigate = useNavigate();
  const categories = ['React', 'JavaScript', 'Web Development', 'Frontend', 'Backend', 'DevOps', 'AI/ML', 'Mobile'];

  const handleInputChange = (field, value) => {
    if (field.includes('.')) {
      const [parent, child] = field.split('.');
      setFormData(prev => ({
        ...prev,
        [parent]: {
          ...prev[parent],
          [child]: value
        }
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [field]: value
      }));
    }
  };

  const addTag = () => {
    if (currentTag.trim() && !formData.tags.includes(currentTag.trim())) {
      setFormData(prev => ({
        ...prev,
        tags: [...prev.tags, currentTag.trim()]
      }));
      setCurrentTag('');
    }
  };

  const removeTag = (tagToRemove) => {
    setFormData(prev => ({
      ...prev,
      tags: prev.tags.filter(tag => tag !== tagToRemove)
    }));
  };

  const addImage = () => {
    if (currentImage.trim() && !formData.additionalImages.includes(currentImage.trim())) {
      setFormData(prev => ({
        ...prev,
        additionalImages: [...prev.additionalImages, currentImage.trim()]
      }));
      setCurrentImage('');
    }
  };

  const removeImage = (urlToDelete) => {
    setFormData(prev => ({
      ...prev,
      additionalImages: prev.additionalImages.filter(url => url !== urlToDelete)
    }));
  };
  // code to handle feature image/videos
  const handleFeaturedUpload = async (file) => {
    if (!file) return;
    const storage = getStorage();
    const timestamp = Date.now();
    const filePath = `blogImages/featured/${timestamp}-${file.name}`;
    const fileRef = ref(storage, filePath);
    const type = file.type.startsWith('video') ? 'video' : 'image';

    setUploading(true);
    try {
      const snapshot = await uploadBytes(fileRef, file);
      const downloadURL = await getDownloadURL(snapshot.ref);
      console.log("download url", downloadURL)
      setFormData((prev) => ({
        ...prev,
        featuredImage: downloadURL,
        featuredType: type, // <-- save type+++++++++++
      }));
    } catch (error) {
      console.error("Featured upload failed:", error);
    }
    setUploading(false);
  };
  // code to handle the additional images/videos
  const handleFileUpload = async (files) => {
    const storage = getStorage();
    const blogId = `blog-${Date.now()}`;
    const uploadedUrls = [];

    setUploading(true);

    for (let file of files) {
      const fileRef = ref(storage, `blogImages/additional/${blogId}/${file.name}`);
      try {
        const snapshot = await uploadBytes(fileRef, file);
        const downloadURL = await getDownloadURL(snapshot.ref);
        uploadedUrls.push(downloadURL);
      } catch (error) {
        console.error("Upload error:", error);
      }
    }

    setFormData((prev) => ({
      ...prev,
      additionalImages: [...prev.additionalImages, ...uploadedUrls],
    }));

    setUploading(false);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const db = getFirestore();
      await addDoc(collection(db, "blogs"), formData);
      setShowSuccess(true);
      console.log("Blog saved successfully");
    } catch (error) {
      console.error("Error saving blog:", error);
    }
    finally {
      setFormData({
        title: '',
        content: '',
        author: {
          name: '',
          bio: '',
          avatar: ''
        },
        category: '',
        tags: [],
        featuredImage: '',
        additionalImages: []
      })
    }
  };

  const isFormValid = formData.title && formData.content && formData.author.name && formData.category;

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Paper elevation={3} sx={{ p: 4, borderRadius: 3 }}>
        <Button onClick={() => navigate("/blogs")}>
          Back
        </Button>
        <Box sx={{ mb: 4, textAlign: 'center' }}>
          <ArticleIcon sx={{ fontSize: 48, color: 'primary.main', mb: 2 }} />
          <Typography variant="h3" component="h1" gutterBottom sx={{ fontWeight: 'bold' }}>
            Create New Blog Post
          </Typography>
          <Typography variant="subtitle1" color="text.secondary">
            Share your knowledge with the world
          </Typography>
        </Box>

        <form onSubmit={handleSubmit}>
          <Grid container spacing={4}>
            {/* Basic Information */}
            <Grid item xs={12}>
              <Card sx={{ mb: 3 }}>
                <CardContent>
                  <Typography variant="h5" gutterBottom sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                    <ArticleIcon sx={{ mr: 1 }} />
                    Basic Information
                  </Typography>

                  <TextField
                    fullWidth
                    label="Blog Title"
                    variant="outlined"
                    value={formData.title}
                    onChange={(e) => handleInputChange('title', e.target.value)}
                    required
                    sx={{ mb: 3 }}
                    placeholder="Enter an engaging title for your blog post"
                  />

                  <TextField
                    fullWidth
                    label="Content"
                    variant="outlined"
                    multiline
                    rows={12}
                    value={formData.content}
                    onChange={(e) => handleInputChange('content', e.target.value)}
                    required
                    placeholder="Write your blog content here..."
                    sx={{ mb: 3 }}
                  />

                  <FormControl fullWidth required>

                    <TextField
                      value={formData.category}
                      // placeholder='Catogory*'
                      label="Category"
                      onChange={(e) => handleInputChange('category', e.target.value)}
                      startAdornment={<CategoryIcon sx={{ mr: 1, color: 'action.active' }} />}
                    >

                    </TextField>
                  </FormControl>
                </CardContent>
              </Card>
            </Grid>


            {/* Images/videos */}
            <Grid item xs={12} md={12}>
              <Card>
                <CardContent>
                  <Typography variant="h5" gutterBottom sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                    <ImageIcon sx={{ mr: 1 }} />
                    Feature Images/Videos
                  </Typography>
                  <Box
                    sx={{
                      border: '2px dashed #ffb74d',
                      borderRadius: 2,
                      padding: 2,
                      textAlign: 'center',
                      backgroundColor: '#fff8e1',
                      cursor: 'pointer',
                      mb: 2,
                    }}
                    onClick={() => document.getElementById('featuredInput').click()}
                    onDragOver={(e) => e.preventDefault()}
                    onDrop={(e) => {
                      e.preventDefault();
                      handleFeaturedUpload(e.dataTransfer.files[0]);
                    }}
                  >
                    <Typography variant="body1" color="textSecondary">
                      Click or drag a video/image to upload as Featured Media (Banner)
                    </Typography>
                    <input
                      id="featuredInput"
                      type="file"
                      accept="image/*,video/*"
                      hidden
                      onChange={(e) => handleFeaturedUpload(e.target.files[0])}
                    />
                  </Box>

                  {/* Preview of Featured Media */}
                  {formData.featuredImage && (
                    <Grid item xs={12} sm={6} md={4}>
                      <Box
                        sx={{
                          position: 'relative',
                          borderRadius: 2,
                          overflow: 'hidden',
                          boxShadow: 1,
                          width: '100%',
                          height: 200,
                        }}
                      >
                        {formData.featuredType === 'video'  ? (
                          <video
                            src={formData.featuredImage}
                            controls
                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                          />
                        ) : (
                          <img
                            src={formData.featuredImage}
                            alt="Featured"
                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                          />
                        )}
                        <IconButton
                          size="small"
                          onClick={() =>
                            setFormData((prev) => ({ ...prev, featuredImage: '' }))
                          }
                          sx={{
                            position: 'absolute',
                            top: 5,
                            right: 5,
                            bgcolor: 'rgba(0,0,0,0.6)',
                            color: 'white',
                            '&:hover': { bgcolor: 'rgba(255,0,0,0.7)' },
                          }}
                        >
                          <CancelIcon fontSize="small" />
                        </IconButton>
                      </Box>
                    </Grid>
                  )}


                  <Divider sx={{ mt: 2 }} />
                  <Typography variant="h5" gutterBottom sx={{ display: 'flex', alignItems: 'center', mb: 3, mt: 2 }}>
                    <ImageIcon sx={{ mr: 1 }} />
                    Additonal Images/Videos
                  </Typography>
                  <Box
                    sx={{
                      border: '2px dashed #90caf9',
                      borderRadius: 2,
                      padding: 2,
                      textAlign: 'center',
                      backgroundColor: '#f5f5f5',
                      cursor: 'pointer',
                      mb: 2,
                    }}
                    onClick={() => document.getElementById('fileInput').click()}
                    onDragOver={(e) => e.preventDefault()}
                    onDrop={(e) => {
                      e.preventDefault();
                      handleFileUpload(e.dataTransfer.files);
                    }}
                  >
                    <Typography variant="body1" color="textSecondary">
                      Drag & drop images/videos here or click to browse
                    </Typography>
                    <input
                      id="fileInput"
                      type="file"
                      accept="image/*,video/*"
                      multiple
                      hidden
                      onChange={(e) => handleFileUpload(e.target.files)}
                    />
                  </Box>
                  {uploading && (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mt: 2 }}>
                      <CircularProgress color="primary" />
                      <Typography variant="body2" sx={{ ml: 2 }}>Uploading files, please wait...</Typography>
                    </Box>
                  )}

                  {/* Uploaded File Previews */}
                  <Grid container spacing={2}>
                    {formData.additionalImages.map((url, index) => (
                      <Grid item xs={6} sm={4} md={3} key={index}>
                        <Box
                          sx={{
                            position: 'relative',
                            borderRadius: 2,
                            overflow: 'hidden',
                            boxShadow: 1,
                          }}
                        >
                          {url.match(/\.mp4|\.webm|\.ogg/) ? (
                            <video
                              src={url}
                              controls
                              style={{ width: '100%', height: '150px', objectFit: 'cover' }}
                            />
                          ) : (
                            <img
                              src={url}
                              alt={`uploaded-${index}`}
                              style={{ width: '100%', height: '150px', objectFit: 'cover' }}
                            />
                          )}
                          <IconButton
                            size="small"
                            onClick={() => removeImage(url)}
                            sx={{
                              position: 'absolute',
                              top: 5,
                              right: 5,
                              bgcolor: 'rgba(0,0,0,0.6)',
                              color: 'white',
                              '&:hover': { bgcolor: 'rgba(255,0,0,0.7)' },
                            }}
                          >
                            <CancelIcon fontSize="small" />
                          </IconButton>
                        </Box>
                      </Grid>
                    ))}
                  </Grid>



                </CardContent>
              </Card>
            </Grid>

            {/* Author Information */}
            <Grid item xs={12} md={12}>
              <Card>
                <CardContent>
                  <Typography variant="h5" gutterBottom sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                    <PersonIcon sx={{ mr: 1 }} />
                    Author Information
                  </Typography>

                  <TextField
                    fullWidth
                    label="Author Name"
                    variant="outlined"
                    value={formData.author.name}
                    onChange={(e) => handleInputChange('author.name', e.target.value)}
                    required
                    sx={{ mb: 2 }}
                  />

                  <TextField
                    fullWidth
                    label="Author Bio"
                    variant="outlined"
                    multiline
                    rows={3}
                    value={formData.author.bio}
                    onChange={(e) => handleInputChange('author.bio', e.target.value)}
                    placeholder="Brief description about the author"
                    sx={{ mb: 2 }}
                  />

                  <TextField
                    fullWidth
                    label="Author Avatar URL"
                    variant="outlined"
                    value={formData.author.avatar}
                    onChange={(e) => handleInputChange('author.avatar', e.target.value)}
                    placeholder="https://example.com/avatar.jpg"
                  />

                  {formData.author.avatar && (
                    <Box sx={{ mt: 2, display: 'flex', alignItems: 'center' }}>
                      <Avatar src={formData.author.avatar} sx={{ mr: 2 }} />
                      <Typography variant="body2" color="text.secondary">
                        Avatar Preview
                      </Typography>
                    </Box>
                  )}
                </CardContent>
              </Card>
            </Grid>



            {/* Tags */}
            <Grid item xs={12}>
              <Card>
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    Tags
                  </Typography>

                  <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
                    <TextField
                      fullWidth
                      label="Add Tag"
                      variant="outlined"
                      size="small"
                      value={currentTag}
                      onChange={(e) => setCurrentTag(e.target.value)}
                      onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                          e.preventDefault();
                          addTag();
                        }
                      }}
                      placeholder="e.g., React, JavaScript, Tutorial"
                    />
                    <IconButton
                      onClick={addTag}
                      color="primary"
                      disabled={!currentTag.trim()}
                    >
                      <AddIcon />
                    </IconButton>
                  </Box>

                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                    {formData.tags.map((tag, index) => (
                      <Chip
                        key={index}
                        label={tag}
                        onDelete={() => removeTag(tag)}
                        color="primary"
                        variant="outlined"
                      />
                    ))}
                  </Box>
                </CardContent>
              </Card>
            </Grid>

            {/* Submit Button */}
            <Grid item xs={12}>
              <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
                <Button
                  type="submit"
                  variant="contained"
                  size="large"
                  disabled={!isFormValid}
                  startIcon={<CloudUploadIcon />}
                  sx={{
                    px: 6,
                    py: 2,
                    borderRadius: 3,
                    fontSize: '1.1rem',
                    fontWeight: 'bold'
                  }}
                >
                  Publish Blog Post
                </Button>
              </Box>
            </Grid>
          </Grid>
        </form>
      </Paper>

      <Snackbar
        open={showSuccess}
        autoHideDuration={4000}
        onClose={() => setShowSuccess(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert severity="success" sx={{ width: '100%' }}>
          Blog post created successfully!
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default BlogPostForm;